import tuneInRequest from '../tuneInRequest';
export default function infoMessagesService(config, apiContext) {
    const apiEndpoint = `${config.domains.api}/infoMessages`;
    function get(key) {
        return tuneInRequest({
            method: 'get',
            url: `${apiEndpoint}/${key}?viewmodel=false`,
            noAuthHeader: true,
        }, apiContext);
    }
    return {
        get,
    };
}
